module.exports = __webpack_public_path__ + "img/csm_Ersa-ECOSELECT4-01-900x675_115ce2cb97.f5a58d82.png";